import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from './configuration';
import * as ReimbursementReducer from '../../../../redux/reducers/reimbursements_list_reducer/selectors';
import { useDispatch } from 'react-redux';
import ReimbursementsListActions from '../../../../redux/reducers/reimbursements_list_reducer/actions';
import { Box } from '@material-ui/core';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';

export default function DatatableList() {
  const ROLE = AuthSelectors.useSelectUserRole();

  const result = ReimbursementReducer.useGetReimbursementsList();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const schemeType = query.get('schemeType');
  const isPending = query.get('isPending') === 'true' ? true : false;
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(schemeType && { schemeType }),
    ...(isPending && { isPending }),
  };

  return (
    <Box display="flex" flexDirection="column">
      {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
        <Filter
          vat_number={vat_num}
          schemeType={schemeType}
          isPending={isPending}
          role={ROLE}
        />
      )}

      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            ReimbursementsListActions.fetchReimbursementsListAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </Box>
  );
}
